// Mock data for Shree Bhawani Equipment (clone styled after westernequipments.com)
// All content is placeholder / demo data. Swap with real data later.

export const company = {
  name: "Bhawani Kitchen Equipment",
  shortName: "Bhawani",
  logo: "/bhawani-logo.png",
  tagline: "Your Kitchen. Our Equipment. Complete Solution.",
  whatsapp: "+91 9930097204",
  phones: ["9372645048", "9082982579", "9987880988", "7718808040"],
  email: "info@bhawanikitchen.com",
  website: "bhawanikitchen.com",
  address: "Gala No. 30, 1st Floor, Lobpsons and Tania Industries, Near HP Petrol Pump, National Highway No. 48, Vasai Phata, Vasai East, Vasai-Virar, Maharashtra 401208",
  social: {
    facebook: "https://www.facebook.com/BhawaniKitchenEquipments280",
    linkedin: "#",
    youtube: "https://www.youtube.com/@bhawanikitchenequipments7399",
    instagram: "https://www.instagram.com/bhawanikitchenequipment280/",
  },
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Gallery", href: "#gallery" },
  { label: "Industries", href: "#industries" },
  { label: "Dealership", href: "#dealership" },
  { label: "Blog", href: "#blogs" },
  { label: "Contact Us", href: "#contact" },
];

export const dealerBenefits = [
  { title: "Exclusive Territory", desc: "Get protected regional rights to grow the Bhawani brand in your area." },
  { title: "Factory Pricing", desc: "Enjoy the best dealer margins with direct-from-manufacturer pricing." },
  { title: "Service & Spares", desc: "Fast access to genuine spare parts and dedicated after-sales support." },
  { title: "Marketing Support", desc: "Catalogues, product images and promotional material to help you sell." },
];

export const heroImage =
  "https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const products = [
  {
    name: "Visi Cooler",
    desc: "Glass door coolers engineered for perfect beverage & dairy chilling.",
    image: "https://images.unsplash.com/photo-1769867967096-e31141e37d49?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Deep Freezer",
    desc: "Hard-top & glass-top deep freezers for reliable frozen storage.",
    image: "https://images.unsplash.com/photo-1651380237745-c6612216e271?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Vertical Freezer",
    desc: "Upright freezers with maximum capacity and even cooling.",
    image: "https://images.unsplash.com/photo-1601599967100-f16100982063?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Pastry Cabinet",
    desc: "Elegant display refrigeration for desserts, cakes & pastries.",
    image: "https://images.pexels.com/photos/5498223/pexels-photo-5498223.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    name: "Confectionery Cabinet",
    desc: "Premium golden-series cabinets that make your products shine.",
    image: "https://images.pexels.com/photos/5498228/pexels-photo-5498228.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    name: "Stainless Steel Range",
    desc: "Upright & under-counter stainless steel refrigeration units.",
    image: "https://images.unsplash.com/photo-1755935776861-39d40cc8261b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Ice Machine",
    desc: "High-output ice makers delivering crescent, cube & flake ice.",
    image: "https://images.pexels.com/photos/29834252/pexels-photo-29834252.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    name: "Back Bar",
    desc: "Under-counter bar refrigeration for impeccable drink service.",
    image: "https://images.unsplash.com/photo-1782179284780-51e93ba88ce7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Dishwasher",
    desc: "Commercial dishwashers built for high-volume kitchens.",
    image: "https://images.pexels.com/photos/29834274/pexels-photo-29834274.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    name: "Water Cooler",
    desc: "Durable water coolers for offices, retail & institutions.",
    image: "https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const industries = [
  {
    title: "Hotels & Restaurants",
    desc: "Precision refrigeration solutions for hotels and restaurants, from Visi Coolers to Dishwashers, ensuring food safety and quality.",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    title: "Cafe\u2019s",
    desc: "Our pastry cabinets and Visi Coolers cater to cafe needs, maintaining optimal temperatures for dairy, desserts, and beverages.",
    image: "https://images.unsplash.com/photo-1516197227520-4d1c419f6ec6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    title: "Retail & Supermarkets",
    desc: "For supermarkets and retail, our visi coolers and deep freezers provide precise cooling, preserving perishables efficiently.",
    image: "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    title: "Bar & Beverage",
    desc: "Elevate the Bar & Beverage industry with our Back Bar refrigeration, Ice Making Machines, and Visi Coolers.",
    image: "https://images.unsplash.com/photo-1572116469696-31de0f17cc34?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
];

export const researchImage =
  "https://images.unsplash.com/photo-1581094271901-8022df4466f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";
export const facilityImage =
  "https://images.unsplash.com/photo-1716193696093-9c54b6a290e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";
export const aboutImage =
  "https://images.unsplash.com/photo-1589109807644-924edf14ee09?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export const brands = [
  "Amul", "Mother Dairy", "Coca-Cola", "Pepsi", "Starbucks", "Dunkin",
  "Cadbury", "Hyatt", "Marriott", "Oberoi", "Burger King", "McDonald's",
  "Domino's", "Subway", "Unilever", "Godrej", "ITC", "Haldiram",
  "Pizza Hut", "OYO", "Hilton", "Radisson", "Blue Tokai", "Cafe Coffee Day",
];

export const stats = [
  { value: "45+", label: "Nations Served" },
  { value: "40+", label: "Years of Excellence" },
  { value: "6", label: "Manufacturing Units" },
  { value: "1M+", label: "Units Delivered" },
];

export const sustainability = [
  {
    title: "E-Waste",
    desc: "Supporting and investing in carbon-neutral industries, processes, innovations and approaches.",
    icon: "Recycle",
  },
  {
    title: "Quality & Certification",
    desc: "Certified with ISO 45001, ISO 20400, ISO 14001, ISO 13485, ISO 9001 & ISO 17025.",
    icon: "ShieldCheck",
  },
  {
    title: "CSR Policy",
    desc: "Driving sustainable development through aligned programs, enriching communities. Compliant with Companies Act 2013.",
    icon: "HeartHandshake",
  },
];

export const blogs = [
  {
    title: "Built for the Rush: What \u201cPremium\u201d Really Means for Your Kitchen Counter",
    category: "Premium Undercounter Drawer",
    excerpt:
      "Commercial kitchens today are expected to do more with less space. Whether it\u2019s a QSR, cloud kitchen, hotel, or bakery, speed and efficiency matter\u2026",
    date: "July 18, 2025",
    image: "https://images.pexels.com/photos/6375553/pexels-photo-6375553.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    title: "Commercial Vending Machines: The Future of Smart Self-Service Retail",
    category: "Vending Machine",
    excerpt:
      "India\u2019s retail landscape is evolving rapidly. Expanding metro networks, airports and business parks are creating high-footfall locations\u2026",
    date: "July 16, 2025",
    image: "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    title: "Low Height Drawer Series \u2013 Cook Above. Chill Below.",
    category: "Low Height Drawer Series",
    excerpt:
      "Commercial kitchens are designed for speed, precision and consistency. Yet one common challenge often goes unnoticed \u2013 the distance to chilled ingredients\u2026",
    date: "July 14, 2025",
    image: "https://images.unsplash.com/photo-1589109807644-924edf14ee09?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];
